import { useEffect, useState } from 'react'
import { Button, Checkbox, FormInput, Modal } from 'components'
import {
  getPanelConfigSchema,
  humanizeKey,
  isFieldDisabled,
  resolveConfig
} from '../panel-config'

export const ConfigModal = ({ type, config, show, hideModal, onSave }) => {
  const schema = getPanelConfigSchema(type)
  const [draft, setDraft] = useState({})

  // Re-init from saved config every time the modal opens
  useEffect(() => {
    if (show) setDraft(resolveConfig(schema, config))
  }, [show, type, config])

  if (!schema) return null

  const handleChange = ({ target: { name, type: inputType, checked, value } }) => {
    setDraft((prev) => ({
      ...prev,
      [name]: inputType === 'checkbox' ? checked : value
    }))
  }

  return (
    <Modal show={show} hideModal={hideModal} title={`Configure ${type}`}>
      {Object.entries(schema).map(([key, field]) =>
        field.type === 'boolean' ? (
          <Checkbox
            key={key}
            name={key}
            label={field.label || humanizeKey(key)}
            checked={!!draft[key]}
            onChange={handleChange}
          />
        ) : (
          <FormInput
            key={key}
            name={key}
            label={field.label || humanizeKey(key)}
            type={field.type === 'number' ? 'number' : 'text'}
            placeholder={field.placeholder}
            disabled={isFieldDisabled(field, draft)}
            value={draft[key] ?? ''}
            onChange={handleChange}
          />
        )
      )}
      <Button onPress={() => onSave(draft)}>Save</Button>
    </Modal>
  )
}
